import script from "./OverlaySelecao.vue?vue&type=script&setup=true&lang=js"
export * from "./OverlaySelecao.vue?vue&type=script&setup=true&lang=js"

import "./OverlaySelecao.vue?vue&type=style&index=0&id=5c2207dc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2207dc"]])

export default __exports__